import { Outlet, ScrollRestoration } from "react-router-dom";
import { PWAInstallPrompt } from "./components/PWAInstallPrompt";
import { PWAInitializer } from "./components/PWAInitializer";
import { OfflineQueueSync } from "./components/OfflineQueueSync";
import { SnackbarQueue } from "@rmwc/snackbar";
import { queue } from "./components/SnackbarQueue";
import { Layout } from "./components/Layout";

// Import RMWC styles are handled in main.tsx or global.css, but we can import specific ones here if needed.

export default function App() {
  return (
    <div className="app-container">
      <PWAInitializer />
      <OfflineQueueSync />
      <Layout>
        <Outlet />
      </Layout>
      <PWAInstallPrompt />
      <SnackbarQueue messages={queue.messages} />
      <ScrollRestoration />
    </div>
  );
}
